import { type UseQueryResult } from '@tanstack/react-query'
import { type KeycloakProfile } from 'keycloak-js'
import { useKeycloakInstance, useKeycloakInstanceSafe } from './KeycloakInstanceProvider'
import { useExecuteTanStackQuery } from './useExecuteTanStackQuery'

/**
 * Get our Keycloak user profile data
 *
 * This is pointing to an account datasource on our SSO keycloak endpoint.
 * On our Keycloak Instance this data is only available when we asked to load our user data,
 * in order to get this profile data in React we (Henk Erik) created this hook.
 */
export const useProfile = (): UseQueryResult<KeycloakProfile> => {
  const keycloakInstance = useKeycloakInstance()
  return useExecuteTanStackQuery(keycloakInstance)
}

/**
 * Get Keycloak user profile data in a safe way.
 * This hook will return `undefined` when a Keycloak instance could not be retrieved,
 * due to the user being offline or something else.
 */
export const useProfileSafe = (): UseQueryResult<KeycloakProfile> | undefined => {
  const keycloakInstance = useKeycloakInstanceSafe()
  return useExecuteTanStackQuery(keycloakInstance, keycloakInstance !== undefined)
}
